/**
 * Página de Acesso Negado do Sistema MEDICARE
 * Página exibida quando um usuário não tem permissão para acessar o sistema
 */

import React from 'react';
import {
  Box,
  Button,
  Container,
  VStack,
  Text,
  Heading,
  useColorModeValue,
  Flex,
  Icon,
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
} from '@chakra-ui/react';
import { FiShield, FiLogOut } from 'react-icons/fi';
import { useAuth } from '../../contexts/AuthContext';

export const AccessDeniedPage: React.FC = () => {
  const { logout, usuario } = useAuth();
  const bgColor = useColorModeValue('gray.50', 'gray.900');
  const textColor = useColorModeValue('gray.600', 'gray.400');

  const handleLogout = () => {
    logout();
  };

  return (
    <Flex
      minH="100vh"
      align="center"
      justify="center"
      bg={bgColor}
      px={4}
    >
      <Container maxW="md" textAlign="center">
        <VStack spacing={8}>
          {/* Ícone de acesso negado */}
          <Box>
            <Icon
              as={FiShield}
              boxSize={20}
              color="red.500"
            />
          </Box>

          {/* Mensagens */}
          <VStack spacing={4}>
            <Heading
              size="xl"
              color={useColorModeValue('gray.800', 'gray.200')}
            >
              Acesso Negado
            </Heading>
            <Text
              fontSize="lg"
              color={textColor}
              maxW="md"
            >
              Você não tem permissão para acessar o sistema MEDICARE.
            </Text>
          </VStack>

          {/* Alerta informativo */}
          <Alert status="warning" borderRadius="md">
            <AlertIcon />
            <Box>
              <AlertTitle>Acesso Restrito!</AlertTitle>
              <AlertDescription>
                O sistema MEDICARE é restrito apenas para médicos e administradores.
                {usuario && (
                  <Text mt={2}>
                    Seu perfil atual: <strong>{usuario.tipo_usuario}</strong>
                  </Text>
                )}
              </AlertDescription>
            </Box>
          </Alert>

          {/* Informações de contato */}
          <VStack spacing={2}>
            <Text fontSize="sm" color={textColor}>
              Se você acredita que isso é um erro, entre em contato com o administrador do sistema.
            </Text>
            <Text fontSize="sm" color={textColor}>
              Email: admin@medicare.com
            </Text>
          </VStack>

          {/* Botão de logout */}
          <Button
            colorScheme="red"
            size="lg"
            leftIcon={<Icon as={FiLogOut} />}
            onClick={handleLogout}
          >
            Fazer Logout
          </Button>
        </VStack>
      </Container>
    </Flex>
  );
};

export default AccessDeniedPage;